import React, { useEffect, useState } from "react";
import { CAProvinces, stateList } from "../../../util/CommonLists";
import { useForm } from "react-hook-form";
import { PATTERNS } from "../../../util/patterns";
import i18nService from "../../../util/Internationalization/i18n/i18n";
import { STEP_PERSONAL_INFORMATION_USER_INFORMATION, STEP_TERMS_OF_USE } from "../ReCompleteRegistrationUtil";
import { GetCountryListAndInternationalSupport } from "../../../util/countryListAndInternationalSupport";
import { registerPageUserData } from "../DisplayOption";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
import { useButtonText } from "../../commonConstants";
interface IProps {
    setForm?: any;
    manageState?: any;
    displayData?: any;
    registrationState?: any;
    setRegistrationState?: any;
    registrationLookup?: any;
    setReCompleteRegistrationState?: any;
}

const AddressInformation = ({ registrationLookup, setReCompleteRegistrationState }: IProps) => {
    const { supportInternational } = GetCountryListAndInternationalSupport();
    const [zipCode, setZipCode] = useState(i18nService.get("ZipCode"));
    //const [zipPattern, setZipPattern] = useState(PATTERNS['ZIPCODE'].pattern);
    let countryValue = i18nService.get("Country");
    if (!countryValue) countryValue = "US";

    const { register, handleSubmit, errors } = useForm({
        mode: "onBlur",
    });

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const [isNextOrContinue, isPreviousOrBack] = useButtonText();
    const onSubmit = (data: any) => {
        setReCompleteRegistrationState({
            ...registrationLookup,
            step: STEP_TERMS_OF_USE,
            address1: data.address1,
            address2: data.address2,
            city: data.city,
            state: data.state,
            zip: data.zipcode,
        });
    };
    const listData = registerPageUserData.personalUserData;
    return (
        <>
            <div className="row" id="content">
                <div className="col-xs">
                    <div className="box box-has-shadow offset-padding">
                        <div className="box-header">
                            <div className="box-title-container">
                                <div className="box-title-icon" aria-hidden="true">
                                    <RenderIcons iconName={"user"} />
                                </div>
                                <div className="box-title-text">
                                    <h2 className="box-title">{listData.step1.title2}</h2>
                                </div>
                            </div>
                        </div>
                        <div className="box-content">
                            <form onSubmit={handleSubmit(onSubmit)} id="register-personal-info-1">
                                <div className="row between-sm">
                                    <div className="col-xs-12 col-sm-7 col-no-gutter">
                                        <p>Complete each step by entering your information in the required fields.</p>
                                        <div className="margin-bottom-l"></div>

                                        <fieldset className="form-row inline">
                                            <div className="row">
                                                <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                    <legend className="legend-label">  <label htmlFor="label-address-line-1">{listData.step1.street}</label></legend>
                                                </div>

                                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                    <div className={`form-row row ${errors["address1"] && "status-error"}`}>
                                                        <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                            <label htmlFor="label-address-line1">Address Line 1 </label>
                                                        </div>
                                                        <div className="form-input col-xs-12 col-no-gutter">
                                                            <input
                                                                type="text"
                                                                name="address1"
                                                                className="inputbox"
                                                                defaultValue={registrationLookup.address1 ? registrationLookup.address1 : ""}
                                                                id="label-address-line-1"
                                                                ref={register({
                                                                    required: true,
                                                                    pattern: PATTERNS.STREETADDRESS.pattern,
                                                                })}
                                                                placeholder="Address Line 1"
                                                            />

                                                            {errors["address1"] && errors["address1"].type === "required" && (
                                                                <span className="form-error">Address Street is required</span>
                                                            )}
                                                            {errors["address1"] && errors["address1"].type === "pattern" && (
                                                                <span className="form-error">{PATTERNS.STREETADDRESS.message}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className={`form-row row ${errors["address2"] && "status-error"}`}>
                                                        <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                            <label htmlFor="label-address-line-2">Address Line 2 </label>
                                                        </div>
                                                        <div className="form-input col-xs-12 col-no-gutter">
                                                            <input
                                                                type="text"
                                                                name="address2"
                                                                className="inputbox"
                                                                defaultValue={registrationLookup.address2 ? registrationLookup.address2 : ""}
                                                                id="label-address-line-2"
                                                                ref={register({
                                                                    pattern: PATTERNS.STREETADDRESS.pattern,
                                                                })}
                                                                placeholder="Address Line 2 (Optional)"
                                                            />

                                                            {errors["address2"] && errors["address2"].type === "pattern" && (
                                                                <span className="form-error">{PATTERNS.STREETADDRESS.message}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>
                                        <fieldset className="form-row inline">
                                            <div className="row">
                                                <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                    <legend className="legend-label"><label htmlFor="label-address-city">City</label></legend>
                                                </div>
                                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                    <div className="row">
                                                        <div className="col-xs-12 col-no-gutter">
                                                            <div className="form-row row">
                                                                <div className="form-input col-xs-12 col-no-gutter">
                                                                    <input
                                                                        type="text"
                                                                        name="city"
                                                                        className="inputbox"
                                                                        defaultValue={registrationLookup.city ? registrationLookup.city : ""}
                                                                        id="label-address-city"
                                                                        ref={register({ required: true, pattern: PATTERNS.CITY.pattern })}
                                                                        placeholder="City"
                                                                    />

                                                                    {errors["city"] && errors["city"].type === "required" && (
                                                                        <span className="form-error">City is required.</span>
                                                                    )}
                                                                    {errors["city"] && errors["city"].type === "pattern" && (
                                                                        <span className="form-error">
                                                                            Invalid Format. City can only include letters, spaces, and the special character: .
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>

                                        <fieldset className="form-row inline">
                                            <div className="row">
                                                {countryValue === "US" || !supportInternational ? (
                                                    <div className={`form-row inline row ${errors["state"] && "status-error"}`}>
                                                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                                            <label htmlFor="label-address-state">State</label>
                                                        </div>
                                                        <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                                            <select
                                                                className="inputbox"
                                                                id="label-address-state"
                                                                defaultValue={registrationLookup.state ? registrationLookup.state : ""}
                                                                name="state"
                                                                ref={register({ required: true, validate: (value) => value !== "---" })}
                                                            >
                                                                {stateList.map((val: any) => (
                                                                    <option key={val.name} value={val.value}>
                                                                        {val.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            {errors["state"] && errors["state"].type === "validate" && (
                                                                <span className="form-error">State is required.</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : countryValue === "CA" ? (
                                                    <div className={`form-row inline row ${errors["state"] && "status-error"}`}>
                                                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                                            <label htmlFor="label-address-state">Province</label>
                                                        </div>
                                                        <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                                            <select
                                                                className="inputbox"
                                                                id="label-address-state"
                                                                defaultValue={registrationLookup.state ? registrationLookup.state : ""}
                                                                name="state"
                                                                ref={register({ required: true, validate: (value) => value !== "---" })}
                                                            >
                                                                {CAProvinces.map((val: any) => (
                                                                    <option key={val.name} value={val.value}>
                                                                        {val.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            {errors["state"] && errors["state"].type === "validate" && (
                                                                <span className="form-error">Province is required.</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className={`form-row inline row ${errors["state"] && "status-error"}`}>
                                                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                                            <label htmlFor="label-address-state">Region</label>
                                                        </div>
                                                        <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                                            <input
                                                                type="text"
                                                                name="state"
                                                                defaultValue={registrationLookup.state ? registrationLookup.state : ""}
                                                                ref={register({ required: true, pattern: PATTERNS.REGION.pattern })}
                                                                className="inputbox"
                                                                id="label-address-state"
                                                            />
                                                            {errors["state"] && errors["state"].type === "required" && (
                                                                <span className="form-error">Region is required.</span>
                                                            )}
                                                            {errors["state"] && errors["state"].type === "pattern" && (
                                                                <span className="form-error">Invalid format. Region can only include letters.</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </fieldset>

                                        <div className={`form-row inline row ${errors["zipcode"] && "status-error"}`}>
                                            <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                                <label htmlFor="label-address-zipcode">{zipCode.Label}</label>
                                            </div>
                                            <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                                <input
                                                    type="text"
                                                    placeholder={zipCode.Label}
                                                    defaultValue={registrationLookup.zip ? registrationLookup.zip : ""}
                                                    className="inputbox"
                                                    id="label-address-zipcode"
                                                    name="zipcode"
                                                    ref={register({ required: true, pattern: PATTERNS[zipCode.Pattern].pattern, maxLength: zipCode.MaxLength })}
                                                />
                                                {errors["zipcode"] && errors["zipcode"].type === "required" && (
                                                    <span className="form-error">{zipCode.Label} is required.</span>
                                                )}
                                                {errors["zipcode"] && errors["zipcode"].type === "pattern" && (
                                                    <span className="form-error">
                                                        Invalid format.{" "}
                                                        {zipCode.Pattern === "ZIPCODE"
                                                            ? `${zipCode.Label} must be entered in either of the two formats: 01234 OR 01234-5678`
                                                            : `${zipCode.Label} must only include digits and letters.`}
                                                    </span>
                                                )}
                                                {errors["zipcode"] && errors["zipcode"].type === "maxLength" && (
                                                    <span className="form-error">
                                                        Invalid format. {zipCode.Label} must be less than {zipCode.MaxLength} in length.
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="margin-vertical-l"></div>

                                <div className="row between-xs">
                                    <div className="col-xs col-no-gutter flex-grow-null"></div>
                                    <div className="col-xs col-no-gutter flex-grow-null">
                                        <ul className="list-inline list-reset">
                                            <li className="margin-left-s">
                                                <button
                                                    type="button"
                                                    className="btn-default btn-default btn-min-width"
                                                    onClick={() => {
                                                        setReCompleteRegistrationState({
                                                            ...registrationLookup,
                                                            step: STEP_PERSONAL_INFORMATION_USER_INFORMATION,
                                                        });
                                                    }}
                                                >
                                                    <span className="btn-text">{isPreviousOrBack}</span>
                                                </button>
                                            </li>
                                            <li className="margin-left-s">
                                                <button
                                                    type="submit"
                                                    className="btn-default btn-primary btn-min-width"
                                                    onClick={() => window.addToDataLayer({ event: "Next Button AddressInformation Click" })}
                                                >
                                                    <span className="btn-text">{isNextOrContinue}</span>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddressInformation;
